module.exports = __webpack_public_path__ + "static/newJoin-1-f5193a23acf8da186702c3718465a045.jpg";